// src/components/popups/CreatorFlameExplainerDrawer.js
import React from 'react';
import './CreatorFlameExplainerDrawer.css';

const n = (v) => Number(v || 0);
const nice = (v, digits = 2) =>
  n(v).toLocaleString(undefined, { maximumFractionDigits: digits });

export default function CreatorFlameExplainerDrawer({
  open,
  onClose,
  score,
  windowLabel,
  likes,
  comments,
  tipCnt,
  tipPi,
  rankIndex,
  rankTotal,

  // optional extra detail
  baseScore = null,
  volumeFactor = null,
  tipPiScaled = null,
  tipCountScaled = null,
}) {
  if (!open) return null;

  const windowText = (windowLabel || '60D').toUpperCase();
  const scoreText = nice(score, 6);
  const hasRank = Number.isFinite(rankIndex) && rankTotal;
  const hasBase = Number.isFinite(n(baseScore));

  return (
    <div className="cfe-overlay" onClick={onClose}>
      <div className="cfe-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="cfe-header">
          <div className="cfe-title">How Creator Flame works</div>
          <button className="cfe-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="cfe-body">
          <p className="cfe-text">
            Creator Flame looks at how strong and consistent your posting has been in the last <b>{windowText}</b>.
          </p>

          <p className="cfe-text cfe-text--intro">
            Your current score is <b>{scoreText}</b>
            {hasRank ? (
              <>
                {' '}and your rank is <b>#{rankIndex}</b> out of <b>{rankTotal}</b> creators in this window.
              </>
            ) : (
              '.'
            )}
          </p>

          <div className="cfe-section-title">What helps your score</div>
          <ul className="cfe-list">
            <li>
              <b>Engagement</b> – posts that get strong likes and comments help the most.
            </li>
            <li>
              <b>Tips</b> – tips help more when they happen across more of your posts, not just one lucky post.
            </li>
            <li>
              <b>Consistency</b> – posting across different days and weeks helps more than posting in one short burst.
            </li>
          </ul>

          <div className="cfe-section-title">How your score is built</div>
          <ol className="cfe-list cfe-list--ordered">
            <li>
              <b>We review your posts in this window.</b> In this period you received about{' '}
              <b>{likes}</b> likes, <b>{comments}</b> comments, <b>{tipCnt}</b> tips and about{' '}
              <b>{nice(tipPi, 6)} Pi</b> in tips.
            </li>

            <li>
              <b>We check post quality.</b> Posts with stronger engagement help more than weak posts.
            </li>

            <li>
              <b>We check how spread out your results are.</b> A creator who performs well across many posts is rewarded more than someone who only has one or two strong posts.
            </li>

            <li>
              <b>We check consistency.</b> Posting across the window helps more than posting everything in one short burst.
            </li>

          </ol>

          <p className="cfe-text cfe-text--highlight">
            A higher score means your content has been stronger, more consistent, and better supported across the full <b>{windowText}</b> window.
          </p>

          <p className="cfe-text cfe-text--hint">
            Tip: The best way to grow your Creator Flame is to post regularly and aim for real engagement across many posts.
          </p>
        </div>

        <div className="cfe-footer">
          <button className="cfe-close-btn" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
